module.exports = __webpack_public_path__ + "static/media/011 I GUERRA M_Comitato ass femminile.d95ca522.svg";